var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-danger",attrs:{"href":"#"},on:{"click":_vm.deleteLesson}},[_vm._v("Delete")])}
var staticRenderFns = []

export { render, staticRenderFns }